const images = {
  logo: require("./logo.svg").default,
};
export default images;
